import { localStorageWrapper } from "@/utils/storage";
import { useEffect, useRef } from "react";

export default function Gofitno({
    onReady = () => {},
    onOpen = () => {},
    onClose = () => {},
    onSendMessage = (d) => {},
    onGetMessage = (d) => {},
}) {
    const gofitnoReadyListener = useRef(null);
    const gofitnoOpenListener = useRef(null);
    const gofitnoCloseListener = useRef(null);
    const gofitnoSendMessageListener = useRef(null);
    const gofitnoGetMessageListener = useRef(null);

    useEffect(() => {
        if (
            typeof window != undefined &&
            !window.Gofitno &&
            !localStorageWrapper.isImpersonated()
        ) {
            const goftinoKey = process.env.NEXT_PUBLIC_GOFTINO_KEY;

            const script = document.createElement("script");
            const source = "https://www.goftino.com/widget/" + goftinoKey;
            const localSource = localStorage.getItem("goftino_" + goftinoKey);

            script.id = "goftinoscript";
            script.type = "text/javascript";
            script.referrerPolicy = "no-referrer-when-downgrade";
            script.src = !!localSource ? source + "?o=" + localSource : source;
            script.defer = true;

            gofitnoReadyListener.current = onReady;
            gofitnoOpenListener.current = onOpen;
            gofitnoCloseListener.current = onClose;
            gofitnoSendMessageListener.current = onSendMessage;
            gofitnoGetMessageListener.current = onGetMessage;

            window.addEventListener(
                "goftino_ready",
                gofitnoReadyListener.current
            );
            window.addEventListener(
                "goftino_openWidget",
                gofitnoOpenListener.current
            );
            window.addEventListener(
                "goftino_closeWidget",
                gofitnoCloseListener.current
            );
            window.addEventListener(
                "goftino_sendMessage",
                gofitnoSendMessageListener.current
            );
            window.addEventListener(
                "goftino_getMessage",
                gofitnoGetMessageListener.current
            );
            document.body.appendChild(script);
        }

        return () => {
            if (gofitnoReadyListener.current) {
                window.removeEventListener(
                    "goftino_ready",
                    gofitnoReadyListener.current
                );
            }
            if (gofitnoOpenListener.current) {
                window.removeEventListener(
                    "goftino_openWidget",
                    gofitnoOpenListener.current
                );
            }
            if (gofitnoCloseListener.current) {
                window.removeEventListener(
                    "goftino_closeWidget",
                    gofitnoCloseListener.current
                );
            }
            if (gofitnoSendMessageListener.current) {
                window.removeEventListener(
                    "goftino_sendMessage",
                    gofitnoSendMessageListener.current
                );
            }
            if (gofitnoGetMessageListener.current) {
                window.removeEventListener(
                    "goftino_getMessage",
                    gofitnoGetMessageListener.current
                );
            }
        };
    }, []);

    return <></>;
}
